<template>
    <nav class="SectionNav" data-section-nav>
        <BaseButton v-for="section in sections" :key="section.key" @click="scrollToSection(section.key)" primary small>
            {{ section.title }}
        </BaseButton>
    </nav>
</template>

<script>
export default {
    name: 'SectionNav',
    props: {
        sections: Object
    },
    setup(props) {
        const scrollToSection = (key) => {
            const section = document.querySelector('[data-entries-section="' + key + '"]');
            section && section.scrollIntoView();
        }

        return {
            scrollToSection
        }
    }
}
</script>

<style lang="scss" scoped>
.SectionNav {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: .25em;
    margin-top: 2rem;

    @media (max-width: 640px) {
        grid-template-columns: 1fr;
    }

    & > * {
        justify-content: center;
    }

    @media(min-width: 900px) {
        position: sticky;
        top: 60px;
        background: #fff;
        z-index: 5;
        padding: 5px 0;
        margin: 0;
    }
}
</style>